import Icon from "src/shared/icons"
import Receta from "../receta/Receta"
import "./Category.css"
import { CategoryProps } from "../OrdenProps.interface"
import { DetalleOrden } from "src/gql/schema"

const icons = {
    Alimentos: "Cutlery",
    Bebidas: "Drink",
    Paquetes: "star",
    Otros: "packageFill",
}

const Category = ({
    category,
    recetas,
    codigoOrden,
    firstCategory,
    ordenLength,
    orderState,
    comandaId,
    currentState,
    orderComandaChangeState
}: CategoryProps) => {
    function acumularRecetas(detalles: DetalleOrden[]) {
        return Object.values(
            detalles.reduce((acc, item) => {
                const comentarios = item.comentarios?.trim() || "";

                // Normaliza los extras para que el orden no afecte la comparación
                const extrasKey = JSON.stringify(
                    [...(item.extras || [])].sort((a, b) =>
                        JSON.stringify(a).localeCompare(JSON.stringify(b))
                    )
                );

                const key = [
                    item.almacen_articulo_id,
                    item.estado,
                    comentarios,
                    extrasKey,
                ].join("|");

                if (!acc[key]) {
                    acc[key] = {
                        ...item,
                        cantidad: 0,
                        detalle_orden_ids: [],
                    };
                }

                acc[key].cantidad += item.cantidad;
                acc[key].detalle_orden_ids.push(item.detalle_orden_id);

                return acc;
            }, {})
        );
    }

    const recetasAcumuladas = acumularRecetas(recetas)

    return (
        <div className="category-receta-container">
            <div className="category-receta-container__header">
                <Icon name={icons[category]} className="category-receta-container__icon" width={12} height={12} />
                <p className="category-receta-container__title">{category}</p>
            </div>

            {recetasAcumuladas.map((receta, index) => (
                <div key={index}>
                    <Receta
                        orderComandaChangeState={orderComandaChangeState}
                        currentState={currentState}
                        button={firstCategory && ordenLength === 1}
                        codigoOrden={codigoOrden}
                        receta={receta as DetalleOrden}
                        orderState={orderState}
                        comandaId={comandaId}
                    />
                    {recetas.length - 1 !== index && <div className="category-receta-container__divider"></div>}
                </div>
            ))}
        </div>
    )
}

export default Category
